import Backbone from 'backbone'
import template from './bookmarks-edit.hbs'
import EditButtons from 'scoreboard/components/edit/edit-buttons'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import DisplayHeader from 'scoreboard/components/display-header'
import conductor from 'scoreboard/components/conductor'
import formHelper from 'scoreboard/components/form-helper'
import spectator from 'scoreboard/components/spectator'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import bookmarks from 'scoreboard/bookmarks/bookmarks'
import highlight from 'scoreboard/components/highlight'
import AttachOrglessV2Report from './attach-orgless-v2-report'
import { handleDeletedBookmark } from './bookmarks-overview'
import notFound from 'scoreboard/components/not-found.hbs'
import EmptyState from 'scoreboard/components/empty-state'
import appDisplay from 'scoreboard/components/app-display'
import tabs from '../components/tabs'

var BookmarksEdit = Backbone.View.extend({

	// this.model is a Bookmark

	tagName: 'form',

	className: 'table-hack display-layout bookmarks-edit',

	events: {
		'click .go-to-origin': 'navigateToSpectated',
		'click .cancel': 'cancel'
	},

	initialize: function() {
		this.spectated = this.model.get('spectated')
		this.editButtons = new EditButtons(this.context())
		this.editButtons.on('delete', this._afterDelete.bind(this))

		this.formView = new FormView({
			el: this.el,
			toggleCancel: true,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		spectator.setCurrent(this.model)

		if (!this.spectated) {
			this.renderNotFound()
			return
		}

		var section = conductor.section(this.model.get('url'))
		if (section.indexOf('?') != -1) {
			this.$el.html('Invalid URL<br><br>' + this.model.get('url'))
			return this
		}

		var headerContext = {
			id: conductor.id(this.model.get('url')),
			section: section,
			overviewTabCode: 'common.view'
		}

		let metadataTabs = tabs[section].tabs(headerContext)
		this.header = new DisplayHeader({
			model: this.model,
			heading: this.spectated.label,
			staticHeading: true,
			subsection: 'edit',
			tabs: metadataTabs
		})

		this.$el.empty().append(this.header.el)
		this.header.render()
		this.$el.append(template(this.model.attributes))

		//#20095 handle org-less reports
		if (section.indexOf('reports') != -1 && _.isNil(this.spectated.organizationId)) {
			let model = new Backbone.Model(this.spectated)
			_.invoke(this._attachV2Report, 'remove')
			this._attachV2Report = new AttachOrglessV2Report({el: this.$('.scroll-container'), model}).render()
			this._attachV2Report.on('done', orgId => {
				this.spectated.organizationId = orgId
				this.render()
			})
			//don't use regular report url, since there is no org associated with this report yet
			this.$('.overview-tab .sp-navigate').attr('href',
				spectator.buildSpectatedUrl(this.model))
			return this
		}

		this.$('.edit-buttons-container').append(this.editButtons.render().$el.addClass('edit-buttons-bottom'))
		// change the first tab (whichever it is) to point at the bookmarks overview
		this.$('.tabs .tab').eq(0).find('a')
			.attr('href', spectator.buildSpectatedUrl(this.model))
		if (this.model.get('type') == 'folder') {
			this.$('.message').remove()
		}

		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		this.formView.start()

		return this
	},

	renderNotFound() {
		handleDeletedBookmark(this.model, BookmarksEdit.prototype)
		appDisplay.display(new EmptyState({
			body: notFound(),
			notFound: true 	// required for #19648
		}))
	},

	navigateToSpectated: function() {
		conductor.navigateToSpectated(this.model.get('url'), this.spectated)
	},

	_afterDelete: function() {
		bookmarks.remove(this.model.get('url'))
	},

	context: function () {
		// #9838 set up custom delete confirmation message used by delete-confirmation.js
		let highlightLabel = highlight(this.model.get('label'))
		let message = i18n.get('common.delete.confirmation.withName',
			this.model.get('type'), highlightLabel)
		let context = {
			section: 'bookmarks',
			model: this.model,
			confirmDeleteMessage: message,
			disableCopyButton: true,
			disableMoveButton: true
		}
		return context
	},

	cancel: function() {
		formHelper.writeToDom(this.model, this.el)
		this.formView.start()
	},

	submit: function() {
		var data = formHelper.readFromDom(this.el)
		return this.model.save(data, {
			patch: true,
			success: function(model) {
				Backbone.trigger('edit:domain-object', model, model.get('relativeId'))
				this.formView.start()
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.editButtons, this.header, this.formView, this.labelField, this._attachV2Report], 'remove')
	}

})

export default BookmarksEdit

BookmarksEdit.__filename__ = 'bookmarks/bookmarks-edit.js'
